import {HeaderBiddingConfig} from "header-bidding-client-base/modules/config/domain/headerBiddingConfig";
import {GlobalConfig} from "header-bidding-client-base/modules/config/domain/globalConfig";
import type {IConfigLoader} from "header-bidding-client-base/modules/config/domain/iConfigLoader";
import type {IConfigDTO} from "services-comun-meteored/modules/services/header-bidding/interface";

declare global {
    interface Window {
        __hbConfig__?: IConfigDTO;
    }
}

export class WindowConfigLoader implements IConfigLoader {

    public async loadConfig() {
        const headerBiddingConfig = this.loadHeaderBiddingConfig();
        const globalConfig = this.loadGlobalConfig();

        this.parseQueryString(globalConfig);

        return {
            headerBiddingConfig,
            globalConfig,
        };
    }

    protected loadHeaderBiddingConfig(): HeaderBiddingConfig {
        if (!window['__hbConfig__']) {
            throw new Error("Config not found");
        }

        return HeaderBiddingConfig.createFromDTO(window['__hbConfig__']);
    }

    protected loadGlobalConfig(): GlobalConfig {
        if (!window['__hbConfig__']) {
            throw new Error("Config not found");
        }

        return GlobalConfig.createFromDTO(window['__hbConfig__']);
    }

    private parseQueryString(globalConfig: GlobalConfig) {
        if (!window.location.search) {
            return;
        }

        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.has("hb_debug")) {
            globalConfig.log_level = "log";
            globalConfig.env = "development";
        }
    }
}
